import { Attributes, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class CreateInstrumentCommand extends ModelBase {

    public description: string = "";

    public isin: string = "";

    public ticker: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public maturityDate: Date | null = null;

    public isListedInstrumentInd: boolean = false;

    public instrumentSubType: string | null = null;

    public instrumentSubTypeID: number | null = null;

    @Attributes.NoTracking()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public currentDate: Date = new Date();

    public isDeletedInd: boolean = false;

    public isDualListed : boolean = false;

    public isREIT: boolean = false;

    // Client only properties / methods
    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }
}